var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClipboardCheck = function SvgClipboardCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 77 77"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "M28.804 16.004h-6.4a6.4 6.4 0 0 0-6.4 6.4v38.4a6.4 6.4 0 0 0 6.4 6.4h32a6.4 6.4 0 0 0 6.4-6.4v-38.4a6.4 6.4 0 0 0-6.4-6.4h-6.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "m28.805 44.806 6.4 6.4 12.8-12.8m-19.2-22.4a6.4 6.4 0 0 1 6.4-6.4h6.4a6.4 6.4 0 0 1 0 12.8h-6.4a6.4 6.4 0 0 1-6.4-6.4"
  })));
};
export default SvgClipboardCheck;